import { Fab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { beachActions, beachSelectors } from "../../../redux";
import DeleteDialog from "../../DeleteDialog";
import TableBeach from "../../TableBeach";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  addButton: {
    marginTop: 20,
  },
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  input: {
    display: "none",
  },
}));

const BeachPage = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState("");
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleDeleteDialogOpen = (id: string) => {
    setDeleteId(id);
    setIsDeleteDialogOpen(true);
  };
  const handleCloseDeleteDialogOpen = () => {
    dispatch(beachActions.clear("deletedBeach"));
    dispatch(beachActions.loadAllBeach({}));
    setIsDeleteDialogOpen(false);
  };

  const handleCreateNewBeach = () => {
    history.push("/beach/edit/");
  };

  const handleEditBeach = (id: string) => {
    history.push(`/beach/edit/${id}`);
  };

  return (
    <div>
      <div className={classes.actionButtons}>
        <Fab onClick={handleCreateNewBeach} variant="extended" color="primary">
          <AddIcon></AddIcon>Crea nuova spiaggia
        </Fab>
      </div>
      <TableBeach
        onDeleteBeach={handleDeleteDialogOpen}
        onEditBeach={handleEditBeach}
      ></TableBeach>
      <DeleteDialog
        isOpen={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialogOpen}
        deleteAction={beachActions.deleteBeachById}
        selector={beachSelectors.getDeletedBeach}
        id={deleteId}
      />
    </div>
  );
};

export default BeachPage;
